import type { ReactNode } from 'react';
import { SnackbarProvider } from 'notistack';
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

/** Snackbars, anchored bottom-right as in the original app. */
export default function NotistackProvider({ children }: { children: ReactNode }) {
  const theme = useTheme();

  return (
    <SnackbarProvider
      dense
      maxSnack={5}
      preventDuplicate
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      style={{
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        fontFamily: theme.typography.fontFamily,
      }}
    >
      {children}
    </SnackbarProvider>
  );
}
